let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kCIje")).then(() => parcelRequire('3Htia'));